
<div class="card">
  <div class="card-header">
    <div class="d-flex justify-content-between align-items-center">
      <div class="card-title">
        Job Logs
      </div>

      <button
        type="button"
        title="Refresh Logs"
        class="btn btn-primary btn-round"
        (click)="refresh()"
        data-testid="job-logs-refresh-logs">
        <i class="fa-solid fa-rotate-right"></i>
      </button>
    </div>
  </div>

  <div class="card-body p-0">
    <div class="filter">
      <div class="title mr-5">Filter: </div>

      <div class="date-filter">
        <div class="d-flex align-items-center">
          <label for="start-date" class="nowrap mr-2 mb-0 p-0">Start </label>
          <input
            [(ngModel)]="filter.startDate"
            type="date"
            id="start-date"
            class="form-control"
            (change)="filterByDate()"
            data-testid="job-logs-start-date">
        </div>

        <div class="d-flex align-items-center">
          <label for="end-date" class="nowrap mr-2 mb-0 p-0">End </label>
          <input
            [(ngModel)]="filter.endDate"
            type="date"
            id="end-date"
            class="form-control"
            (change)="filterByDate()"
            data-testid="job-logs-end-date">
        </div>

        <div class="d-flex align-items-center">
          <label for="text-filter" class="nowrap mr-2 mb-0 p-0">Search </label>
          <input
            [(ngModel)]="filter.searchText"
            type="text"
            id="text-filter"
            class="form-control"
            data-testid="job-logs-search-text">
        </div>

        <button
          type="button"
          class="btn btn-primary"
          (click)="getJobLogs()"
          data-testid="job-logs-search">
          <i class="fa fa-search mr-1"></i>
          Search
        </button>

        <div class="d-flex align-items-center">
          <input
            [(ngModel)]="filter.errorsOnly"
            id="errors-only"
            type="checkbox"
            (change)="filterByErrorsOnly()"
            class="mx-1 my-1"
            data-testid="job-logs-errors-only-checkbox">
          <label for="errors-only" class="mx-1 my-1">Errors Only</label>
        </div>
      </div>

      <button
        *ngIf="filter.logTypeId"
        class="btn btn-secondary py-1"
        (click)="removeTypeFilter()"
        data-testid="job-logs-remove-type-filter">
        Type: {{ filter.logTypeName }}
        <i class="fa fa-times"></i>
      </button>

      <button
        type="button"
        *ngIf="filter.userId"
        class="btn btn-secondary py-1"
        (click)="removeUserFilter()"
        data-testid="job-logs-remove-user-filter">
        User: {{ filter.userName }}
        <i class="fa-solid fa-times"></i>
      </button>

      <div class="flex-spacer"></div>

      <button
        type="button"
        class="btn btn-secondary py-1"
        (click)="resetFilters()"
        data-testid="job-logs-reset">
        Reset
        <i class="fa-solid fa-times"></i>
      </button>
    </div>

    <ngx-datatable
      *ngIf="!isRerendering"
      #table
      class="material striped job-table-height"
      [rows]="jobLogs"
      [loadingIndicator]="isLoading"
      itemsPerPage="50"
      [headerHeight]="40"
      [footerHeight]="40"
      [rowHeight]="45"
      [scrollbarV]="true"
      [columnMode]="columnMode.force"
      [sorts]="[{prop: 'timestamp', dir: 'desc'}]"
    >
      <!-- Timestamp -->
      <ngx-datatable-column
        cellClass="text-center"
        headerClass="text-center"
        name="Timestamp"
        prop="timestamp"
        [resizeable]="false"
        [sortable]="true"
        [width]="200"
        [maxWidth]="200"
      >
        <ng-template ngx-datatable-cell-template let-timestamp="value">
          <div>{{getTimestampString(timestamp)}}</div>
        </ng-template>
      </ngx-datatable-column>

      <!-- Log Type -->
      <ngx-datatable-column
        cellClass="text-left"
        headerClass="text-left"
        name="LogType"
        prop="logType"
        [sortable]="true"
        [width]="150"
        [maxWidth]="200"
      >
        <ng-template ngx-datatable-cell-template let-row="row" let-logType="value" let-rowIndex="rowIndex">
          <div class="d-flex align-items-center">
            <div
              class="filterable"
              (click)="filterByLogType(row)"
              [attr.data-testid]="'job-logs-filter-by-log-type-' + rowIndex">
              {{logType}}
            </div>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <!-- User -->
      <ngx-datatable-column
        headerClass="text-center"
        name="User"
        prop="userName"
        [sortable]="true"
        [width]="250"
        [maxWidth]="300"
      >
        <ng-template ngx-datatable-cell-template let-userName="value" let-row="row" let-rowIndex="rowIndex">
          <div class="user-name w-100">
            <ng-container *ngIf="row.userId; else systemTriggered">
              <div
                [title]="userName"
                class="w-100 filterable"
                (click)="filterByUser(row)"
                [attr.data-testid]="'job-logs-filter-by-user-' + rowIndex">
                <div class="text-center">{{userName}}</div>
              </div>
            </ng-container>

            <ng-template #systemTriggered>
              <div
                title="System Generated"
                class="w-100"
              >
                <div class="text-center">-- System --</div>
              </div>
            </ng-template>
          </div>
        </ng-template>
      </ngx-datatable-column>

       <!-- Detail -->
      <ngx-datatable-column
        cellClass="text-left flex-grow-1"
        headerClass="text-center flex-grow-1"
        name="Message"
        prop="detail"
        [resizeable]="true"
        [width]="250"
        [maxWidth]="undefined"
      >
        <ng-template ngx-datatable-cell-template let-row="row" let-detail="value">
          <div class="d-flex justify-content-between">
            <div>{{detail}}</div>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <!-- Errors -->
      <ngx-datatable-column
        cellClass="text-center"
        headerClass="text-center"
        name="Success"
        prop="hasErrors"
        [sortable]="true"
        [width]="20"
        [minWidth]="20"
      >
        <ng-template ngx-datatable-cell-template let-row="row" let-hasErrors="value">
          <i *ngIf="!hasErrors" class="fa fa-check text-success"></i>
          <i *ngIf="hasErrors" class="fa fa-xmark text-danger"></i>
        </ng-template>
      </ngx-datatable-column>

      <!-- Actions -->
      <ngx-datatable-column
        cellClass="text-center"
        headerClass="text-center"
        name="Detail"
        prop="details"
        [width]="50"
      >
        <ng-template ngx-datatable-cell-template let-row="row" let-details="value" let-rowIndex="rowIndex">
          <div *ngIf="row.hasError"></div>
          <button
              *ngIf="row.details"
              type="button"
              class="btn btn-primary log-details-button"
              (click)="showDetails(row)"
              [attr.data-testid]="'job-logs-show-details-' + rowIndex">
              View {{details.length}} Detail(s)
          </button>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
</div>

<app-job-log-detail-modal></app-job-log-detail-modal>





// WEBPACK FOOTER //
// ./src/app/developer/logs/job-logs/job-logs.component.html